import { render, staticRenderFns } from "./UpdatePersonalInfoEmail.vue?vue&type=template&id=83eac6d0"
import script from "./UpdatePersonalInfoEmail.vue?vue&type=script&lang=js"
export * from "./UpdatePersonalInfoEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports